/*
 * <variant-specs> — Met à jour le contenu d'un bloc lié à un metachamp de VARIANTE
 * (ici l'accordéon « Caractéristiques » → custom.caracteristiques_decli) à chaque
 * changement de variante, sans rechargement de page.
 *
 * Mécanisme du thème (FoxTheme / Pillar) : à chaque sélection de variante, <product-info>
 * re-fetch la section produit (rendue avec la nouvelle variante) puis publie l'événement
 * pubsub `variantChange` avec le DOM re-rendu (event.data.html) et la variante.
 * On récupère, dans ce DOM, le fragment <variant-specs> de même id (déjà rendu côté
 * serveur, rich text inclus) et on le recopie dans l'élément visible. Aucune duplication
 * de données, aucune dépendance externe.
 */
if (!customElements.get('variant-specs')) {
  customElements.define(
    'variant-specs',
    class VariantSpecs extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        // FoxTheme.pubsub peut ne pas être encore prêt selon l'ordre des scripts `defer` :
        // on attend qu'il le soit plutôt que d'abandonner définitivement.
        this.subscribeWhenReady();
      }

      subscribeWhenReady(attempts) {
        attempts = attempts || 0;

        if (
          window.FoxTheme &&
          FoxTheme.pubsub &&
          FoxTheme.pubsub.PUB_SUB_EVENTS &&
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange
        ) {
          this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
            this.onVariantChange.bind(this)
          );
          return;
        }

        if (attempts > 50) return; // ~5s max
        setTimeout(this.subscribeWhenReady.bind(this, attempts + 1), 100);
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      onVariantChange(event) {
        if (!event || !event.data || event.data.sectionId !== this.sectionId) return;

        // event.data.html : Document re-rendu de la section pour la nouvelle variante.
        const source = event.data.html.getElementById(this.id);
        if (!source) return;

        this.innerHTML = source.innerHTML;
      }
    }
  );
}
